import type { Bounds as GraphqlBounds } from "@/services/graphql/generated";

export const convertToGraphqlBounds = (
  latLngBounds: google.maps.LatLngBounds | null
): GraphqlBounds | null => {
  if (!latLngBounds || !("getNorthEast" in latLngBounds)) {
    return null;
  }

  const ne = latLngBounds.getNorthEast();
  const sw = latLngBounds.getSouthWest();

  return {
    north: ne.lat(),
    south: sw.lat(),
    east: ne.lng(),
    west: sw.lng(),
  };
};
